import { render, staticRenderFns } from "./JQcorneaOrder.vue?vue&type=template&id=0ce966c1&scoped=true&"
import script from "./JQcorneaOrder.vue?vue&type=script&lang=js&"
export * from "./JQcorneaOrder.vue?vue&type=script&lang=js&"
import style0 from "./JQcorneaOrder.vue?vue&type=style&index=0&id=0ce966c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce966c1",
  null
  
)

export default component.exports